import type { ButtonProps, SRT_RowData, SRT_TableInstance } from '../../types'

import { Button } from '@/shared/components/ui/button'
import {
	Tooltip,
	TooltipContent,
	TooltipTrigger,
} from '@/shared/components/ui/tooltip'

export type SRT_ExpandAllButtonProps<TData extends SRT_RowData> = {
	table: SRT_TableInstance<TData>
} & ButtonProps

export const SRT_ExpandAllButton = <TData extends SRT_RowData>({
	table,
	...rest
}: SRT_ExpandAllButtonProps<TData>) => {
	const {
		getCanSomeRowsExpand,
		getIsAllRowsExpanded,
		getIsSomeRowsExpanded,
		getState,
		options: {
			icons: { KeyboardDoubleArrowDownIcon },
			localization,
			renderDetailPanel,
		},
		toggleAllRowsExpanded,
	} = table
	const { isLoading } = getState()

	const isAllRowsExpanded = getIsAllRowsExpanded()

	return (
		<Tooltip>
			<TooltipTrigger asChild>
				<Button
					variant='ghost'
					size='icon-sm'
					disabled={
						isLoading || (!renderDetailPanel && !getCanSomeRowsExpand())
					}
					onClick={() => toggleAllRowsExpanded(!isAllRowsExpanded)}
					aria-label={localization.expandAll}
					{...rest}
				>
					<KeyboardDoubleArrowDownIcon
						style={{
							transform: `rotate(${isAllRowsExpanded ? -180 : getIsSomeRowsExpanded() ? -90 : 0}deg)`,
							transition: 'transform 150ms',
						}}
					/>
				</Button>
			</TooltipTrigger>
			<TooltipContent>
				{isAllRowsExpanded ? localization.collapseAll : localization.expandAll}
			</TooltipContent>
		</Tooltip>
	)
}
